import { useEffect, useRef, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faCopy, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { SuscriptionTypeApi, SuscriptionTypeDataType } from "@/api/SuscriptionTypeApi";
import { showAlert } from "@utils/Alert";
import { formatMoneyValue } from "@utils/Currency";
import { CurrencyApi, CurrencyDataType } from "@/api/CurrencyApi";

const SuscriptionTypeIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);
  const [currencies, setCurrencies] = useState<CurrencyDataType[]>([])

  useEffect(() => {
    loadCurrencies();
  }, []);

  const loadCurrencies = async () => {
    const { items: currencies } = await CurrencyApi.fetchAll();
    setCurrencies(currencies)
  }

  const getCurrencyId = (currencyId: string) => {
    const currencyData = currencies.find(c => c.id == currencyId);
    if (currencyData) {
      return currencyData.currency_id || 1
    } else {
      return 1
    }
  }

  const deleteRecord = async (id: string) => {
    const { errors } = await SuscriptionTypeApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'El Tipo de suscription no puedo ser eliminado');
    } else {
      showAlert('success', 'El tipo de suscription fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  return (
    <PageContainer
      title="Lista Tipos de Suscripciones"
      backUrl="/admin/suscriptions"
      primaryActions={[
        {
          onClick: () => {
            navigate('/admin/suscription-types/add')
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<SuscriptionTypeDataType>
        ref={modelRef}
        messages={{
          noResults: "No hay tipos de Suscripciones creadas aun"
        }}
        fetchData={(...args) => SuscriptionTypeApi.fetchAll(...args)}
        filterProps={[
          {
            key: "nombre",
            filterType: "eq"
          }
        ]}
        secondaryProperties={[
          {
            key: "nombre",
            title: "Nombre",
          },
          {
            key: (data) => {
              return formatMoneyValue(Number(data.monto || 0), getCurrencyId(`${data.currencyId}`))
            },
            title: "Monto",
            highlighted: true
          }
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "4", md: "5" },
            { sm: "4", md: "3" },
          ]
        }
        listActions={[
          {
            href: "/admin/suscription-types/copy/{:id}",
            actionTitle: "Copiar Tipo Suscripcion",
            iconProps: { icon: faCopy }
          },
          {
            href: "/admin/suscription-types/edit/{:id}",
            actionTitle: "Editar Tipo Suscripcion",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Tipo de Suscription",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Tipo de Suscription",
              confirmMessage: "¿Seguro que desea eliminar este tipo de Suscription?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>
    </PageContainer >
  );
}

export default SuscriptionTypeIndex;
